import { useEffect } from 'react';

var useOnKeydownTrigger = function (keyName, handler) {
  useEffect(function () {
    var handleKeyDown = function (_a) {
      var key = _a.key;
      key === keyName && handler();
    };
    window.addEventListener("keydown", handleKeyDown);
    return function () {
      return window.removeEventListener("keydown", handleKeyDown);
    };
  }, [keyName, handler]);
};

export { useOnKeydownTrigger };
//# sourceMappingURL=use-on-keydown-trigger.js.map
